<template>
  <div class="bg-gray-900 rounded-lg p-2">
    <router-link
      class="flex justify-between"
      :to="``"
    >
      <h1 class="text-gray-300 text-sm">ملیت</h1>
      <ExternalLinkIcon class="h-5 w-5 text-yellow-500" />
    </router-link>
    <div class="flex justify-center  w-screen overflow-auto">
      <LoadingSpinner
        class="h-10 w-10 text-yellow-500/80 my-8"
        v-if="loading"
      />
      <apexchart
      height="350px"
        class="flex justify-center w-screen"
        type="bar"
        :options="options"
        :series="series"
        v-else-if="this.series[0].data.length"
      />
      <h6 class="my-8 text-gray-600" v-else>بدون داده</h6>
    </div>
  </div>
</template>
<script>
import { getCountByNashnality } from "../../API/API";
import LoadingSpinner from "../General/LoadingSpinner";
import { ExternalLinkIcon } from "@heroicons/vue/outline";

export default {
  name: "CountByNashnality",
  components: { LoadingSpinner, ExternalLinkIcon },
  props: ["month", "day"],
  data() {
    return {
      loading: true,
      series: [
        {
          data: [],
        },
      ],
      options: {
        chart: {
          type: "bar",
          foreColor: "#d1d5d3",
        },
        labels: [],
        xaxis: {
          labels: {
            show: true,
            rotate: 90,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: false,
            minHeight: undefined,
            maxHeight: 120,
            style: {
              colors: [],
              fontSize: "12px",
              fontFamily: "iransans",
              fontWeight: 400,
              cssClass: "apexcharts-xaxis-label",
            },
            offsetX: 0,
            offsetY: 0,
            format: undefined,
            formatter: undefined,
            datetimeUTC: true,
            datetimeFormatter: {
              year: "yyyy",
              month: "MMM 'yy",
              day: "dd MMM",
              hour: "HH:mm",
            },
          },
        },
      },
    };
  },
  created() {
    this.getReports();
  },
  methods: {
    getReports() {
      this.series = [  {
          data: [],
        },];
      this.options.labels = [];
      this.loading = true;
      getCountByNashnality("month", "qty", "", this.month, this.day).then(
        (resp) => {
          resp.data.result.yaxis.forEach((item) => {
            this.series[0].data.push({
              x: item.name,
              y: item.data[0],
            });
          });
          this.loading = false;
        }
      );
    },
  },
  watch: {
    day() {
      if (this.day !== "") this.getReports();
    },
    month() {
      this.getReports();
    },
  },
};
</script>
<style scoped></style>
